import React, { useState, useEffect } from 'react';
import useApi from '../../helpers/TerserahApi';
import { PageArea, SearchArea, Fake, BannerCarousel } from './style';
import { PageContainer, FeaturedAdsCarousel, SEO } from '../../components';
import { Link } from 'react-router-dom';
import { AdItem } from '../../components';
import { useTranslation } from 'react-i18next';
import CategoryIcon from '../../components/CategoryIcon';

const Page = () => {
  const api = useApi();
  const { t } = useTranslation();

  const [stateList, setStateList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [adList, setAdList] = useState([]);
  const [featuredAds, setFeaturedAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);

  const bannerImages = [
    '/images/banner-terserah.jpg',
    '/images/comercial01.jpg',
    '/images/comercial02.jpg'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % bannerImages.length);
    }, 5000); // Cambia cada 5 segundos

    return () => clearInterval(interval);
  }, [bannerImages.length]);

  useEffect(() => {
    const getStates = async () => {
      const stateList = await api.getStates();
      setStateList(stateList);
    };
    getStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getCategories = async () => {
      const allCategories = await api.getCategories();
      // Filter only main categories (parent_id is null or undefined)
      const mainCategories = allCategories.filter(cat => !cat.parent_id);
      setCategories(mainCategories);
    };
    const getRecentAds = async () => {
      const json = await api.getAds({
        sort: 'desc',
        limit: 8,
      });
      setAdList(json.ads);
      setLoading(false);
    };
    const getFeaturedAds = async () => {
      const json = await api.getAds({
        sort: 'desc',
        limit: 12,
        is_featured: true,
      });
      setFeaturedAds(json.ads);
    };
    getCategories();
    getRecentAds();
    getFeaturedAds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SEO
        title="Terserah - Buy and Sell in Indonesia | #1 Marketplace"
        description="Terserah is Indonesia's leading marketplace. Buy and sell new and used products: electronics, fashion, home, vehicles and more. Post for free!"
      />
      <SearchArea>
          <div className="searchBox">
            <form method="GET" action="/ads">
              <input type="text" name="q" placeholder={t('search')} />
              <select name="state" defaultValue="">
                {stateList.map((item, key) => (
                  <option value={item.uf} key={key}>{item.name}</option>
                ))}
              </select>
              <button>{t('searchButton')}</button>
            </form>
          </div>
          <div className="categoryList">
            {loading ? <Fake height="70" fillContent/>
            : categories.map((item, key) => (
                <Link key={key} to={`/ads?cat=${item.slug}`} className="categoryItem">
                  <CategoryIcon icon={item.icon} size={32} categoryId={item.id} />
                  <span>{t(item.name)}</span>
                </Link>
              ))
            }
          </div>
      </SearchArea>
      <BannerCarousel>
        <div className="carouselContainer">
          {bannerImages.map((img, index) => (
            <div
              key={index}
              className={`carouselSlide ${index === currentSlide ? 'active' : ''}`}
              style={{ display: index === currentSlide ? 'block' : 'none' }}
            >
              <img src={img} alt={`Banner ${index + 1}`} />
            </div>
          ))}
          <button 
            className="carouselBtn prev" 
            onClick={() => setCurrentSlide((prev) => (prev - 1 + bannerImages.length) % bannerImages.length)}
          >
            ‹
          </button>
          <button 
            className="carouselBtn next" 
            onClick={() => setCurrentSlide((prev) => (prev + 1) % bannerImages.length)}
          >
            ›
          </button>
          <div className="carouselDots">
            {bannerImages.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        </div>
      </BannerCarousel>
      <FeaturedAdsCarousel ads={featuredAds} loading={loading} />
      <PageContainer>
        <PageArea>
          <div className="list">
          {loading ? <Fake height="300" fillContent/>
          : adList.length > 0
            ? adList.map((item, key) => (
                <AdItem key={key} data={item} />
              ))
            : <div className="noAds">
                {t('noAds')}
                <Link to="/post-an-add">{t('postFirstAd')}</Link>
              </div>
          }
          </div>
          <Link to="/ads" className="seeAllLink">{t('seeAll')}</Link>
        </PageArea>
      </PageContainer>
    </>
  );
};

export default Page;